import App from '../../common/app/app';


class MainApp extends App {

	injectCurrentLinkManager(currentLinkManager) {
		this.currentLinkManager = currentLinkManager;
	}


	injectDummyTracker(dummyTracker) {
		this.dummyTracker = dummyTracker;
	}


	injectHashScroller(hashScroller) {
		this.hashScroller = hashScroller;
	}


	injectPageSlots(pageSlots) {
		this.pageSlots = pageSlots;
	}


	injectPages(pages) {
		this.pages = pages;
	}


	init() {
		this.contexts.setDefaultContext('default', false);
		return super.init();
		// .then(() => {
		// 	this.loader = this.getComponent('appLoader');
		// });
	}


	execute() {
		this.pages.initCurrent()
			// .then(() => {
			// 	console.log('before loader animation');
			// 	return this.loader.playAnimation();
			// })
			.then(() => {
				this.contexts.getContext('default').activate();
				this.currentLinkManager.update();
				const hash = location.hash;
				if (hash.length) {
					this.events.trigger(document.body, 'history:hashchange', {hash: hash.substr(1)});
				}
			})
		;
	}

}

export default MainApp;
